module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "part",
    attrs: {
      "epub:type": "part",
      "id": "part-001"
    }
  }, [_c('div', {
    staticClass: "part_debut"
  }), _c('h1', {
    staticClass: "part_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('b', [_vm._v("Commentary on Joshua")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW:")])]), _vm._v(" The authorship of Joshua was a matter of some debate among the reformers. Most recognize Joshua son of Nun as the author, but also associate Eleazar the high priest with the final form of the text. Indeed, some attribute the book to Eleazar rather than to Joshua. All reformers would agree with Arthur Jackson that whoever wrote or contributed to the book, they did so under the inspiration of the Holy Spirit, the ultimate author of the book.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-016"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('b', [_c('i', [_vm._v("Prolegomena")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOULD")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USPEND")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDGMENT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORSHIP")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" As to the author of this book, it is better to suspend our judgment than to make random assertions. Those who think that it was Joshua, because his name stands on the title page, rest on weak and insufficient grounds. The name of Samuel is inscribed on a part of the sacred history containing a narrative of the events which happened after his death; and there cannot be a doubt that the book which immediately follows the present is called Judges, not because it was written by them, but because it recounts their exploits. Joshua died before the taking of Hebron and Debir, and yet an account of it is given in the fifteenth chapter of the present book. The probability is that a summary of events was framed by the high priest Eleazar, and furnished the materials out of which the book of Joshua was composed. . . . Let us not hesitate, therefore, to pass over a matter which we are unable to determine, or the knowledge of which is not very necessary, while we are in no doubt as to the essential point—that the doctrine herein contained was dictated by the Holy Spirit for our use, and confers benefits of no ordinary kind on those who attentively peruse it. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(", A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RGUMENT OF THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-682",
      "id": "ap_ntf-682-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTH THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBJECT AND THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANN")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERHARD:")]), _vm._v(" The title . . . indicates that Joshua wrote it. . . . You see, it is called “the book of Joshua” not merely with respect to its object but also with respect to its efficient instrumental cause, as we conclude from Joshua 24:26. There is a report that Ezra added to the end of the book the things that were written after the death of Joshua. Theodoret thinks that the entire book was taken long after Joshua’s death from an ancient commentary whose title was “the Book of the Just,” taken from the words of Joshua 10:13. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMONPLACES 1")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-683",
      "id": "ap_ntf-683-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEAZAR")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTH")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKELY")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD A")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND IN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITING THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" It is called the book of Joshua because it contains the history of the acts of Joshua: in his government, conquests, dividing the land, and settling the state and commonwealth of Israel; and because (as it is most probable) it was penned by Joshua, following the example of Moses his predecessor. However, some passages in the book could not be penned by himself, as containing some things which were done after his death; these were afterward inserted by some holy man of God inspired by the Spirit. Calvin thought Eleazar "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("wrote the heads of this book. Masius"), _c('sup', [_vm._v("†")]), _vm._v(" conceives Ezra to have written it. But it appears that the penman, whoever he was, lived before David’s time, and therefore long before Ezra’s. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA, THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RGUMENT")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-684",
      "id": "ap_ntf-684-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTATEUCH, SO")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(".")]), _vm._v(" JOHN MAYER: According to the title of this book, the Hebrews hold that Joshua was the author of it, so likewise [Peter] Comestor,"), _c('sup', [_vm._v("†")]), _vm._v(" Nicholas of Lyra,"), _c('sup', [_vm._v("‡")]), _vm._v(" and many other learned men. And this is proved, first, from Joshua 24:26, where Joshua is expressly said to have written all these words. Second, it is proved from Sirach 46:1, where Joshua is said to have been the successor of Moses in prophecies, and to write the sacred history is a kind of prophesying. For these reasons, this book is numbered among the prophets by the Hebrews. . . . But to return again to Joshua, why should not he most probably be thought the author of this book, seeing he was a most godly judge, and set up in the place of Moses, who so carefully had written acts of God before for the people, that he should do the like for the famous things wrought in his time. Calvin, to the contrary, thinks that Eleazar wrote this book, and not Joshua, because in chapter 15, there is described the taking of Hebron, which was not done till after the death of Joshua. But the inserting of this, and supplying of that, by some other holy writer is no argument that the book was not written by Joshua, any more than the supplying of some things by others in the books of Moses. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA, THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-685",
      "id": "ap_ntf-685-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS AN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORITY")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUAL TO")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOSE OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCAS")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SIANDER:")]), _vm._v(" The book of Joshua (which in the Hebrew is called Jehoshua): in which is described how Joshua led the Israelites into Canaan according to the divine promise. Joshua is a type of Christ, who leads us into eternal life. Citations from this book are made in Matthew 1 (concerning Rahab) and Hebrews 11 (concerning the miraculous destruction of the city of Jericho). Therefore this book has an authority to match that of the books of Moses. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(", P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-686",
      "id": "ap_ntf-686-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITTEN BY")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSPIRATION OF THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")])]), _vm._v(". A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON")]), _vm._v(": Here begins the history of Israel’s commonwealth under the government of Joshua; and therefore it is called the book of Joshua. Some add also that it was so called because it was written by Joshua, which may be judged probable; first, because the example of Moses, who wrote the state of Israel’s commonwealth in his time might be a strong inducement to Joshua to do the like; and second, because Joshua 24:26 is an evident proof that he wrote some part of this book, if not that he wrote it all. It is true, there are some passages in this book that could not have been written by Joshua . . . but even though the book itself was written by Joshua, these passages might be inserted afterward by some other penman of the Holy Ghost. For so also in the foregoing books, which all people grant were written by Moses, we find some passages too that could not be written by Moses himself, but were afterward added by some other, as is noted upon that relation of the death and burial of Moses. However, it is sufficient for us to know that whoever wrote this book, it was written by the inspiration of the Holy Ghost; for this there is a testimony given in the New Testament, where some passages of this book are cited as parts of the sacred Scripture, the Word of God, as that which in this chapter is spoken to Joshua, and cited by Saint Paul. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 1:1")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-687",
      "id": "ap_ntf-687-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MMEDIATE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULFILLMENT OF A")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHECY OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSES")]), _vm._v(".")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENEVA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLE:")]), _vm._v(" In this book the Holy "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("Spirit sets most vividly before our eyes the accomplishment of God’s promise through Moses that a Prophet should be raised up for the people like him, whom he wills they are to obey: so he shows himself here true in his promise, as at all other times, and after the death of Moses his faithful servant, he raises up Joshua to be ruler and governor over his people, so that they neither should be discouraged for lack of a captain, nor have occasion to distrust God’s promises hereafter. And so that Joshua might be confirmed in his vocation, and also so that the people might have no occasion to grudge, as though he were not approved of God, he is adorned with the most excellent gifts and graces of God, both to govern the people with counsel, and to defend them with strength; he lacked nothing that belonged either to a valiant captain or a faithful minister. So he overcomes all difficulties, and brings them into the land of Canaan, which according to God’s ordinance he divides among the people, and sets their borders. Further, he establishes laws and ordinances, and puts the people in remembrance of God’s manifold benefits, assuring them of his grace and favor, if they obey God, and of his plagues and vengeance, if they disobey him. This history foreshadows Jesus Christ the true Joshua, who leads us into eternal felicity, which is signified for us by this land of Canaan. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RGUMENT")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-688",
      "id": "ap_ntf-688-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PITE THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDEEMING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CTS OF THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENCK:")]), _vm._v(" After Moses and Aaron had died and the people had reached the Jordan, God raised up another righteous, courageous, upright, and godly leader for his people by the name of Joshua son of Nun. He was to lead his people through the Jordan, as Moses has led them dry through the Red Sea, that they might conquer the land beyond too. He was strengthened by God, and sent two spies secretly from Shittim saying, “Go, view the land and the city of Jericho.” They went and fulfilled their commission, but with some danger, and told Joshua that God had already given them the land with all its inhabitants. Joshua then went out from Shittim to the Jordan where they tarried for three days. Then they crossed it and came out on the tenth day of the first month to encamp at Gilgal toward sunrise, not far from Jericho. When the kings of the Amorites, who dwelt beyond the Jordan toward sunset, and all the kings of Canaan heard of how the Lord had dried up the rivers of the Jordan before the children of Israel that they might cross over, their hearts were frightened and they were near to death. But the Lord had Joshua circumcise all those who had been born in the wilderness and who were not as yet circumcised. This took place. After that they conquered Jericho. . . . Of these and other such beneficial deeds God wishes to remind his people here, that they might learn once more that God’s hand is the strongest and to fear him always. But they care for none and do as they have always done whatever strikes their fancy. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFLECTIONS ON THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHET")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICAH")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-689",
      "id": "ap_ntf-689-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345225b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1.vue
// module id = 84
// module chunks = 0